import { JwApiError } from "../api/error.js";
import { getEnvVariable } from "../util/environment.js";
import { isEmptyResponse, parseHeaders } from "./util.js";

//#region ../base/fetch/index.ts
/**
* Convert Response object with all of its methods to a plain JS object without any methods.
*/
function responseToPlainObj(response) {
	const { headers, ok, redirected, status, statusText, type, url } = response;
	return {
		headers: Array.from(headers.entries()).reduce((acc, [key, value]) => {
			acc[key] = value;
			return acc;
		}, {}),
		ok,
		redirected,
		status,
		statusText,
		type,
		url
	};
}
async function parseResponse(response, responseMethod, debug = false) {
	const plainResponse = responseToPlainObj(response);
	const isValidHttpStatus = response.status >= 200 && response.status < 300;
	const isResponseOk = response.ok && isValidHttpStatus;
	let data;
	try {
		data = isEmptyResponse(response) ? void 0 : await response[responseMethod]();
		if (isResponseOk) {
			const ret$1 = {
				...plainResponse,
				data
			};
			debug && console.debug("Response:", JSON.stringify(ret$1, null, 2));
			return ret$1;
		}
	} catch (e) {}
	const ret = {
		...plainResponse,
		data: data instanceof Blob ? void 0 : data
	};
	debug && console.debug("Error response:", JSON.stringify(ret, null, 2));
	throw new JwApiError(ret);
}
function objToUrlSearchParams(element, key = "", usp = new URLSearchParams()) {
	if (typeof element === "object") for (const idx in element) objToUrlSearchParams(element[idx], key ? `${key}[${idx}]` : idx, usp);
	else usp.set(key, element);
	return usp;
}
async function wrappedFetch(url, fetchOpts, customOpts) {
	const inputType = customOpts.inputType ?? (typeof fetchOpts.body === "object" ? "json" : void 0);
	let body;
	if (typeof fetchOpts.body !== "undefined") switch (inputType) {
		case "json":
			body = JSON.stringify(fetchOpts.body);
			break;
		case "urlencoded":
			body = objToUrlSearchParams(fetchOpts.body);
			break;
		case "none":
			body = void 0;
			break;
		default:
			body = String(fetchOpts.body);
			break;
	}
	const headers = parseHeaders(fetchOpts.headers, {
		contentType: inputType,
		authToken: customOpts.authToken,
		transformHeaders: customOpts.transformHeaders
	});
	const req = {
		...fetchOpts,
		headers,
		body,
		credentials: getEnvVariable("TEST") ? "include" : "same-origin"
	};
	customOpts.debug && console.debug("Request:", (() => {
		const { signal,...rest } = req;
		return {
			url,
			...rest
		};
	})());
	const response = customOpts.mockFetch ? await customOpts.mockFetch(url, req) : await fetch(url, req);
	const fetchResponse = await parseResponse(response, customOpts.responseType ?? "json", customOpts.debug);
	return fetchResponse;
}

//#endregion
export { wrappedFetch };
//# sourceMappingURL=index.js.map